import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Telemetry, createTelemetryThrottle } from './utils/telemetry';

const isIgnorableWalletConnectProposalError = (value: unknown): boolean => {
  const message =
    typeof value === 'string'
      ? value
      : value && typeof value === 'object' && 'message' in value
        ? String((value as { message?: unknown }).message || '')
        : '';

  return /proposal expired/i.test(message);
};

const shouldLogClientError = createTelemetryThrottle(10_000);

const trackClientError = (eventName: string, errorValue: unknown, metadata?: Record<string, unknown>) => {
  const message =
    typeof errorValue === 'string'
      ? errorValue
      : errorValue && typeof errorValue === 'object' && 'message' in errorValue
        ? String((errorValue as { message?: unknown }).message || '')
        : String(errorValue || 'unknown-error');

  const key = `${eventName}:${message.slice(0, 120)}`;
  if (!shouldLogClientError(key)) {
    return;
  }

  void Telemetry.track({
    event_name: eventName,
    event_category: 'client_runtime',
    level: 'error',
    metadata: {
      message,
      userAgent: navigator.userAgent,
      href: window.location.href,
      ...(metadata || {}),
    },
  });
};

window.addEventListener('unhandledrejection', (event) => {
  if (isIgnorableWalletConnectProposalError(event.reason)) {
    console.warn('Ignored stale WalletConnect proposal rejection');
    event.preventDefault();
    return;
  }

  trackClientError('window_unhandled_rejection', event.reason);
});

window.addEventListener('error', (event) => {
  if (isIgnorableWalletConnectProposalError(event.error || event.message)) {
    console.warn('Ignored stale WalletConnect proposal runtime error');
    event.preventDefault();
    return;
  }

  trackClientError('window_error', event.error || event.message, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
